// extracted by mini-css-extract-plugin
export var pillWrapper = "_yc-0";
export var showOverflow = "_yc-1";